import * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import type * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../../me'
import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * Navigate to either Widgets or Widget Builder depending on whether a widget
 * entity is being edited
 */
export const widgetBuilderNavigate = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    widgetEc: Collection,
    meFeature: me.Feature,
    router: router.Router,
  ) =>
    widgetEc.plugins.currentEntityPlugin.feature.selectors
      .getLatestEntity()
      .asObservable.pipe(
        rxjs.withLatestFrom(router.selectors.routeParams.asObservable),
        rxjs.switchMap(([editedEntity, routeParams]) => {
          // Proceed with navigation only if:
          // 1. We are on Widget list when entity is being edited
          // 2. We are on Widget Builder when entity is not being edited
          const navigationId = editedEntity
            ? ents.extra.prebuilt.AppPageAlias.Widgets
            : ents.extra.prebuilt.AppPageAlias.WidgetBuilder

          return routeParams.appPageAlias === navigationId
            ? meFeature.contexts.selectors
                .getUrlForLink({
                  goto: {
                    navigationId: editedEntity
                      ? ents.extra.prebuilt.AppPageAlias.WidgetBuilder
                      : ents.extra.prebuilt.AppPageAlias.Widgets,
                  },
                })
                .asObservable.pipe(rxjs.take(1))
            : rxjs.of(undefined)
        }),
        rxjs.map(url =>
          url
            ? router.actions.navigate
                .from('widgetBuilderNavigate (effect)')
                .create({ url })
            : store.effects.SKIP,
        ),
      ),
)
